/**
 * Face Verification Page
 *
 * A simple wrapper page for the FaceVerification component.
 * This page is rendered at the /face-liveness route and handles
 * the complete face verification flow.
 */

import { FaceVerification } from "../components/faceVerification";

export function FaceVerificationPage() {
  return <FaceVerification />;
}
